import React from 'react'
import default_cover from '../images/default_cover.jpg'
import { formatSeconds } from '../../utils/formatTime'

export default function Slide(props) {

    return (
        <>
            { 
                props.tvData &&
                <div className='position-relative' title={props.tvData.title}>
                    <img  src={props.type === 2 ? `https://img.cugate.com/?o=CUTV_VIDEO&i=${props.tvData.id}&s=300` : `https://img.cugate.com/?o=CUTV_PLAYLIST&i=${props.tvData.id}&s=300`} alt = ""
                        onError = {({ currentTarget }) => {
                            currentTarget.onerror = null // prevents looping
                            currentTarget.src=default_cover
                        }}
                        style={
                            {
                                objectFit: 'cover',
                                borderRadius:'0.625vw',
                                width: `${props.width}`,
                                aspectRatio: "16/9",
                                cursor: 'pointer'
                            }
                        }>
                    </img>
                    <div className='position-absolute text-white rounded px-1 bg-dark'
                        style={{zIndex:"1000", bottom:"0.05rem", right:"0.2rem"}}>
                        {formatSeconds(props.tvData.duration)}
                    </div>
                </div>
            }
        </>
    )
}
